import type { GroupedCourse } from '../types/course';

/** JSON semantic content, preserving array order and explicit empty values. */
export function courseAdditionContent(value: unknown): string {
  return JSON.stringify(value, (_key, item: unknown) => item && typeof item === 'object' && !Array.isArray(item)
    ? Object.fromEntries(Object.keys(item).sort().map(key => [key, (item as Record<string, unknown>)[key]])) : item);
}
export interface CourseAdditionInverse {
  beforeCount: number;
  afterKey: string;
  addedKey: string;
}
/** Remove exactly the appended individual group, retaining the current prefix. */
export function groupsAfterAdditionUndo(current: GroupedCourse[], inverse: CourseAdditionInverse): GroupedCourse[] | null {
  if (current.length !== inverse.beforeCount + 1 || courseAdditionContent(current) !== inverse.afterKey) return null;
  const added = current[inverse.beforeCount];
  if (!added || added.isCourseList || courseAdditionContent(added) !== inverse.addedKey) return null;
  return current.slice(0, inverse.beforeCount);
}
